import type { RouteObject } from "react-router-dom"
import Home from "@/pages/Home"
import ValeBonusPage from "@/pages/ValeBonusPage"
import { useRoutes } from "react-router-dom"

// EW Pass - Parceria ComproPay routes
export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/valebonus", element: <ValeBonusPage /> },
]

function App() {
  return useRoutes(routes)
}

export default App
